export default "__VITE_ASSET__DgWzA1JX__"